import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "./index.scss";

import ReactDOM from "react-dom";
import smoothscroll from "smoothscroll-polyfill";

import App from "./App";

(async function loadPolyfills() {
  smoothscroll.polyfill();
})();

ReactDOM.render(<App />, document.getElementById("root"));
